import React from "react";
import { Card, Col } from "antd";
import { NavLink } from "react-router-dom";

function DashboardCard({ bgColor, icon, to, text, today = 0, total, isNotToday }) {
  return (
        <NavLink to={to}>
          <div
            title=""
            bordered={true}
            className={`transition-all hover:scale-105 duration-300 h-full dark:text-gray-200 ${bgColor} shadow-lg rounded-2xl`}>
            <div className="h-full p-3 flex flex-col justify-between">
              <div className="flex justify-between items-center h-full">
                <div>
                  <h1 className="text-[18px] font-bold">{total}</h1>
                  <p className="text-[12px] font-medium opacity-90">{text}</p>
                  {!isNotToday && (
                    <p className="text-[10px] font-bold">
                      + {today} Unread
                    </p>
                  )}
                </div>
                <img src={icon} alt="" className="w-10 h-10" />
              </div>
            </div>
          </div>
        </NavLink>
  );
}

export default DashboardCard;
